webpackJsonp([146200195789219],{

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = {"description":"","displayName":"LanguageSwitcher","methods":[{"name":"onUpdate","docblock":null,"modifiers":[],"params":[{"name":"prevProps","type":null}],"returns":null},{"name":"onSelect","docblock":null,"modifiers":[],"params":[{"name":"countryCode","type":null}],"returns":null}],"props":{"showLabel":{"type":{"name":"bool"},"required":false,"description":"Show or hide the label of selected language.","defaultValue":{"value":"false","computed":false}},"disabled":{"type":{"name":"bool"},"required":false,"description":"Disable or enable the component.","defaultValue":{"value":"false","computed":false}},"showOptionLabel":{"type":{"name":"bool"},"required":false,"description":"Show or hide labels in option list.","defaultValue":{"value":"true","computed":false}},"showFlag":{"type":{"name":"bool"},"required":false,"description":"Show or hide flags.","defaultValue":{"value":"true","computed":false}},"showArrow":{"type":{"name":"bool"},"required":false,"description":"Show or hide arrow expand.","defaultValue":{"value":"true","computed":false}},"selectedLanguage":{"type":{"name":"string"},"required":false,"description":"Selected language.","defaultValue":{"value":"''","computed":false}},"placeholder":{"type":{"name":"string"},"required":false,"description":"Placeholder to show when not selected language.","defaultValue":{"value":"'Language'","computed":false}},"languages":{"type":{"name":"arrayOf","value":{"name":"string"}},"required":false,"description":"Array of languages to show, an array with countries codes. The complete list of countries can be found https://github.com/ekwonye-richard/react-flags-select/blob/master/src/countries.js","defaultValue":{"value":"[]","computed":false}},"customLabels":{"type":{"name":"objectOf","value":{"name":"any"}},"required":false,"description":"Configure label of languages.","defaultValue":{"value":"{}","computed":false}},"className":{"type":{"name":"string"},"required":false,"description":"Class to apply.","defaultValue":{"value":"''","computed":false}},"style":{"type":{"name":"objectOf","value":{"name":"any"}},"required":false,"description":"Css style applied to the component","defaultValue":{"value":"null","computed":false}},"onSelect":{"type":{"name":"func"},"required":false,"description":"Called when language selection change. Params `{language}`","defaultValue":{"value":"() => {}","computed":false}}},"filename":"/components/LanguageSwitcher/LanguageSwitcher.jsx"}

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _main = __webpack_require__(5);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _DetailsComponent = __webpack_require__(6);
	
	var _DetailsComponent2 = _interopRequireDefault(_DetailsComponent);
	
	var _languageswitcher = __webpack_require__(519);
	
	var _languageswitcher2 = _interopRequireDefault(_languageswitcher);
	
	var _map = __webpack_require__(1088);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComponentView = function (_React$Component) {
	  _inherits(ComponentView, _React$Component);
	
	  function ComponentView() {
	    _classCallCheck(this, ComponentView);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ComponentView.prototype.render = function render() {
	    return _react2.default.createElement(
	      _main2.default,
	      { pagePushedFunction: this.handlepushedPageLayout },
	      _languageswitcher2.default && _react2.default.createElement(_DetailsComponent2.default, {
	        name: _languageswitcher2.default.name,
	        linkGithub: 'https://github.com/front10/landing-page-book/tree/master/src/components/LanguageSwitcher',
	        description: _languageswitcher2.default.summary,
	        stories: _languageswitcher2.default.stories,
	        importCode: _languageswitcher2.default.import,
	        withStyles: _languageswitcher2.default.withStyles,
	        extractProps: _languageswitcher2.default.extractProps,
	        propsDescription: _map2.default.props
	      })
	    );
	  };
	
	  return ComponentView;
	}(_react2.default.Component);
	
	exports.default = ComponentView;
	module.exports = exports['default'];

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  name: 'Language Switcher',
	  summary: 'Website translation, the process of converting text from a source language into a target language, is also known as website globalization. In order to translate a website into other languages, you may need both website internationalization (I18N) and website localization (L10N). This component allow you to easy change the language on your website.',
	  import: '',
	  withStyles: true,
	  stories: [{
	    name: 'Basic',
	    summary: '',
	    code: '<LanguageSwitcher\n    showLabel placeholder="Select language..."\n    languages={[\'US\', \'FR\', \'ES\', \'DE\']}\n    customLabels={{\n        US: \'English\',\n        FR: \'Fran\xE7ais\',\n        ES: \'Espa\xF1ol\',\n        DE: \'Deutsch\'\n    }}\n/>',
	    tabsActive: ['code']
	  }]
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-components-languageswitcher-js-52ffae2e6d6b36e721d5.js